import { useNavigate } from 'react-router-dom';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { BoolColumn } from '../../components/DataTable/BoolColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { Review } from '../../interfaces/Review/Review';
import { Pagination } from '../../interfaces/Pagination';
import {
  DataTable,
  DataTableVariant,
} from '../../components/DataTable/DataTable';

const columns: TableColumn<Review>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'user-name',
    name: 'Kullanıcı',
    accessor: (row) => <TextColumn value={row.userName} />,
  },
  {
    id: 'product-name',
    name: 'Ürün',
    accessor: (row) => <TextColumn value={row.productName} />,
  },
  {
    id: 'rating',
    name: 'Puan',
    accessor: (row) => <TextColumn value={row.rating.toString()} />,
  },
  {
    id: 'is-active',
    name: 'Durum',
    accessor: (row) => <BoolColumn value={row.isActive} />,
    align: 'center',
  },
];

const additionalColumns: TableColumn<Review>[] = [
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type ReviewsTableProps = {
  reviews: Review[];
  totalCount: number;
  pagination: Pagination;
  onPagination?: (newPagination: Pagination) => void;
  variant?: DataTableVariant;
  headless?: boolean;
};

export const ReviewsTable = (props: ReviewsTableProps) => {
  const navigate = useNavigate();

  return (
    <DataTable
      columns={
        props.variant === 'compact'
          ? columns
          : [...columns, ...additionalColumns]
      }
      totalCount={props.totalCount}
      rows={props.reviews}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination?.({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination?.({ ...props.pagination, page: newPage })
      }
      hidePagination={props.variant === 'compact'}
      onClick={(review) => navigate(`/products/reviews/${review.id}`)}
      headless={props.headless}
    />
  );
};
